/**
 * R-14 (Nicolas 2026-10-01) — `?phase=<id>` est le lien profond qui ouvre le panneau
 * d'un nœud du planning à l'arrivée (notification, courriel : 302 vers
 * `/projects/:id/planning?view=gantt&phase=…`). Quand ce nœud n'existe plus (supprimé depuis
 * son panneau), le paramètre resté dans l'URL rouvrait un panneau mort au rechargement.
 *
 * Retire `phase` SEUL de l'URL courante, sans nouvelle entrée d'historique, en gardant
 * `history.state` (l'identifiant de restauration de Turbo) — même idiome que
 * `remark_auto_open_controller.js`. Ne touche à rien quand il n'y a pas de `phase`.
 *
 * @param {Window} win la fenêtre (injectée : testable sous `node --test`)
 * @returns {boolean} vrai si l'URL a été réécrite
 */
export function forgetPhaseParam(win) {
  const url = new URL(win.location.href);
  if (!url.searchParams.has('phase')) return false;

  url.searchParams.delete('phase');
  win.history.replaceState(win.history.state, '', url.toString());
  return true;
}
